import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

interface RetryConfig extends AxiosRequestConfig {
  retry: number;
  retryDelay: number;
}

const globalConfig: RetryConfig = {
  retry: 3,
  retryDelay: 500,
};

export class DatabaseManager
{
  private static instance: DatabaseManager;
  private axiosInstance: AxiosInstance;

  private constructor() 
  {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_URL + "api",
      headers: {"Content-Type": "application/json"}
    });

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        const { config } = error;
        
        if (!config || !config.retry) {
          return Promise.reject(error);
        }
        config.retry -= 1
        const delayRetryRequest = new Promise<void>((resolve) => {
          setTimeout(() => {
            console.log("retry the request", config.url);
            resolve();
          }, config.retryDelay || 1000)
        })
        return delayRetryRequest.then(() => this.axiosInstance(config));
      }
    );
  }

  public static getInstance(): DatabaseManager 
  {
    if (!DatabaseManager.instance)
      DatabaseManager.instance = new DatabaseManager();
    
    return DatabaseManager.instance;
  }

  public setToken(token: string | undefined):void
  {
    this.axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  public get(url: string)
  {
    return this.axiosInstance.get(url, globalConfig).then((response) => response);
  }

  public getWithArgs(url: string, args: object)
  {
    return this.axiosInstance.get(url, {
      params: args
    }).then((response) => response);
  }

  public post(url: string, body: object)
  {
    return this.axiosInstance.post(url, body, globalConfig).then((response) => response);
  }

  public put(url: string, body: object)
  {
    return this.axiosInstance.put(url, body, globalConfig).then((response) => response);
  }

  public delete(url:string)
  {
    return this.axiosInstance.delete(url, globalConfig).then((response) => response);
  }
}